<template>
  <FancyIconCircle
    v-if="isBoolean"
    class="icon-circle"
    :class="{ 'icon-circle--dull': value === false }"
    size=".85rem"
  >
    <template v-if="value">
      <CheckIcon size="1.25rem" />
      <span class="sr-only">Yes</span>
    </template>
    <template v-else>
      <XIcon size="1rem" />
      <span class="sr-only">No</span>
    </template>
  </FancyIconCircle>
  <span v-else>{{ value }}</span>
</template>

<script>
import { CheckIcon, XIcon, FancyIconCircle } from '@campsite-bio/component-lib';
import { computed, toRefs } from '@nuxtjs/composition-api';

export default {
  components: {
    CheckIcon,
    XIcon,
    FancyIconCircle,
  },

  props: {
    supported: {
      type: [Boolean, Array],
      required: true,
    },

    index: Number,
  },

  setup(props) {
    const { supported, index } = toRefs(props);

    const isBoolean = computed(() => {
      return (
        typeof supported.value === 'boolean' ||
        typeof supported.value[index.value] === 'boolean'
      );
    });
    const isString = computed(() => {
      return (
        !isBoolean.value && typeof supported.value[index.value] === 'string'
      );
    });
    const value = computed(() => {
      return Array.isArray(supported.value)
        ? supported.value[index.value]
        : supported.value;
    });

    return { isBoolean, isString, value };
  },
};
</script>

<style lang="scss" scoped>
.icon-circle.icon-circle {
  background-color: var(--g-color-secondary);
  color: var(--g-color-on-secondary);

  &--dull {
    background-color: var(--g-color-gray-200);
    color: var(--g-color-gray-900);
  }
}
</style>
